import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'patient_id',
  })

  return {
    variables: {
      id,
    },
    pause: !id,
  }
}
